module.exports = __webpack_public_path__ + "static/media/sell.2c65f432.svg";